import { render } from "./UploadImageModal.vue?vue&type=template&id=3841ebc3"
import script from "./UploadImageModal.vue?vue&type=script&lang=js"
export * from "./UploadImageModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__